import { render, staticRenderFns } from "./reporte-deportes.vue?vue&type=template&id=cc09aab8&scoped=true"
import script from "./reporte-deportes.vue?vue&type=script&lang=js"
export * from "./reporte-deportes.vue?vue&type=script&lang=js"
import style0 from "./reporte-deportes.vue?vue&type=style&index=0&id=cc09aab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc09aab8",
  null
  
)

export default component.exports